import { theme } from '../../styles/theme';
import { hexToRgb } from '../../utils/colour-utils';

export const getRgb = (design?: string, asRgbString = false) => {
  let themeColor: string;

  switch (design) {
    case 'Regional programme': {
      themeColor = theme.colors['yellow-100']; // gold
      break;
    }
    case 'Implementation study': {
      themeColor = theme.colors['pale-orange']; // pale orange
      break;
    }
    case 'Clinical trial': {
      themeColor = theme.colors['blue-study']; // blue
      break;
    }
    case 'National programme': {
      themeColor = theme.colors['green-100']; // green (teal)
      break;
    }
    default: {
      // All/undefined - blue-100
      themeColor = theme.colors['blue-100'];
      break;
    }
  }

  const color = hexToRgb(themeColor);
  return asRgbString ? `rgb(${color})` : color;
};
